import React from "react";
import File from './File'
 
const DisplayFile = ({ file, selectFile = null, unselectFile = null, select = null, unselect = null }) => {
  return (
    <div key={file.filename} className="col-md-3">
      <File file={file} 
      selectFile={(data) => selectFile(data)} 
      unselectFile={((data) => unselectFile(data))} 
      select = {select} 
      unselect={unselect} />
    </div>
  )
}

export default DisplayFile;